import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

const handleError = (err, dispatch, action) => {
  if (typeof err.message === "string") {
    dispatch(action(err.message));
  } else if(err.message.length && err.message[0].msg && err.message[0].msg === "N/A") {
    dispatch(action("Unauthorized."));
  } else {
    dispatch(action(err.message[0].msg));
  }
};

export const uploadFileRequested: Action = createAction(ActionTypes.UPLOAD_FILE_REQUESTED);
export const uploadFileReceived: Action = createAction(ActionTypes.UPLOAD_FILE_RECEIVED);
export const uploadFileFailed: Action = createAction(ActionTypes.UPLOAD_FILE_FAILED);
const uploadFileAPI = async (fileId, locationId, buildingId, content, options) => await workflowController.execute("file", null, "upload", {fileId, locationId, buildingId, content}, options);
export const uploadFile = (locationId, buildingId, fileObj) => async (dispatch, getState) => {
  dispatch(uploadFileRequested());
  try {
    const fileId = fileObj.name.replace(".csv", "");
    const content = await fileObj.text();
    const res = await uploadFileAPI(fileId, locationId, buildingId, content, {token: userAccessTokenSelector(getState())});
    console.log(res)
    dispatch(uploadFileReceived());
  } catch (err) {
    handleError(err, dispatch, uploadFileFailed);
  }
};



// WEBPACK FOOTER //
// ./src/features/upload/store/uploadActions.js